export const environment = {
  production: false,
  apiUrl: 'https://api.dev1.instantpaydev.aptyspayments.com',
  jwtCookieName: '9d358f9327bf4549b7b26f67577a0d72',
  useMock: false,
};
